<template>
  <v-col cols="6" md="2" style="padding: 5px;">
    <v-item v-slot="{active, toggle}">
      <v-card :color="active ? '#F6EFEF': white" :class="active ? 'borderme' : 'borderout'"
        class="f-flex align-center rounded-lg" height="90"  @click="toggle">
        <v-row>
          <v-col cols="12" sm="12">
            <v-list-item three-line class="text-center">
              <v-list-item-content>
                <div align="center" justify="center">
                  <v-img src="{group.image}" max-height="80" max-width="80" contain></v-img>
                </div>
                <v-list-item-subtitle :class="active ? 'brown--text' : 'black--text'" class="caption mt-4">
                  {{group.name}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-card>
    </v-item>
  </v-col>
</template>

<script>
export default {
  props: ['group']
}
</script>

<style>
</style>